import tw from 'twin.macro'

const H2 = tw.h2`
text-gray-800 text-xl
`

export default H2
